import {
  logEvent,
  setUserId,
  setUserProperties
} from "firebase/analytics"
import { analytics } from "@/firebase"

/**
 * Screen View Tracking
 */
export const trackScreenView = ({
  screenName,
  screenClass,
  user
}) => {
  logEvent(analytics, "screen_view", {
    screen_name: screenName,
    screen_class: screenClass,
    user_id: user?.id || null,
    role: user?.role || null,
    email: user?.email || null,
    name: user?.name || null
  })
}

/**
 * Set User ID
 */
export const trackSetUserId = (userId) => {
  if (!userId) return
  setUserId(analytics, userId)
}

/**
 * Set User Properties
 */
export const trackSetUserProperties = (user) => {
  if (!user) return

  setUserProperties(analytics, {
    role: user.role,
    email: user.email,
    name: user.name
  })
}
